import { useMemo } from 'react';
import { useAppContext } from '../../../AppContextProvider';
import { useLocalStorage } from '../../../domain/useLocalStorage';
import { CUSTOMER_VEN_PAGE_CONST } from './constants';

export const useCustomerVenSidebar = () => {
    const { isFiltersSidebarEnabled } = useAppContext();

    const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(CUSTOMER_VEN_PAGE_CONST.localStorage.sidebarCollapsedKey, false);

    const layoutPaddingLeft = useMemo(() => {
        if (!isFiltersSidebarEnabled) return '0';

        return sidebarCollapsed ? '35px' : '200px';
    }, [isFiltersSidebarEnabled, sidebarCollapsed]);

    return {
        sidebarCollapsed,
        setSidebarCollapsed,
        layoutPaddingLeft,
        isFiltersSidebarEnabled,
    };
};
